import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EErgoFormService } from '../../../services/e-ergo-form.service';
import { ToastsService } from '../../../services/toasts.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'manual-material-handling',
  templateUrl: './manual-material-handling.component.html',
  styleUrls: ['./manual-material-handling.component.css'],
  providers: []
})
export class ManualMaterialHandlingComponent implements OnInit, OnDestroy {
  private templateName = 'manual-material-handling';

  preventiveEvaluationChoices: string[] = ['General Evaluation', 'Discomfort'];
  choices: string[] = ['Yes', 'No'];

  private BusyA;
  private BusyB;
  private BusyC;
  private BusyD;
  private BusyE;
  private BusyF;

  formId: string = '';
  formData: any;

  profileVideoFilesColl: string[] = [];
  profileVideoFilesFolder: string = 'ProfileVideoFiles'
  rearVideoFilesColl: string[] = [];
  rearVideoFilesFolder: string = 'RearVideoFiles'

  disableSubmit: boolean = true;

  validFormStatus: boolean = false;

  constructor(private eErgoFormService: EErgoFormService, private activatedRoute: ActivatedRoute, private toastsService: ToastsService,
    private titleService: Title) {
    this.titleService.setTitle('Safety Director | ' + this.templateName);
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .subscribe(params => {
        this.formId = params.get('formId')!;

        this.getFormData();
      });
  }

  getFormData() {
    this.BusyA = this
      .eErgoFormService
      .getForm(this.templateName, this.formId)
      .subscribe(result => {
        this.formData = result;

        if (!this.formData.profileVideoBlobs || this.formData.profileVideoBlobs.length <= 0 ||
          !this.formData.rearVideoBlobs || this.formData.rearVideoBlobs.length <= 0) {
          this.disableSubmit = true;
        } else {
          this.disableSubmit = false;
        }

        if (this.formData.status == 'Initiated' || this.formData.status == 'NeedAdditionalInfo') {
          this.validFormStatus = true;
        } else {
          this.validFormStatus = false;
        }
      });
  }

  getFileDetails(e, type) {
    switch (type) {
      case 'profileVideo':
        this.profileVideoFilesColl = [];
        break;
      case 'rearVideo':
        this.rearVideoFilesColl = [];
        break;
    }

    for (let i = 0; i < e.target.files.length; i++) {
      switch (type) {
        case 'profileVideo':
          this.profileVideoFilesColl.push(e.target.files[i]);
          break;
        case 'rearVideo':
          this.rearVideoFilesColl.push(e.target.files[i]);
          break;
      }
    }
  }

  uploadFiles(files, type) {
    if (files.length === 0)
      return;

    let updateFormData = this.compileFormData('');

    this.BusyF = this
      .eErgoFormService
      .updateForm(this.templateName, this.formId, updateFormData)
      .subscribe(result => {
        this.toastsService.showSuccess(`Successfully saved the details.`);

        this.getFormData();

        const formData = new FormData();

        let folderName;

        switch (type) {
          case 'profileVideo':
            folderName = this.profileVideoFilesFolder;
            break;
          case 'rearVideo':
            folderName = this.rearVideoFilesFolder;
            break;
        }

        for (let i = 0; i < files.length; i++) {
          let fileToUpload = <File>files[i];
          formData.append('files', fileToUpload, `${folderName}/${fileToUpload.name} `);
        }

        this.BusyB = this.eErgoFormService.uploadFiles(this.formId, formData).subscribe(response => {
          this.toastsService.showSuccess(`Successfully uploaded.`);
          this.profileVideoFilesColl = [];
          this.rearVideoFilesColl = [];
          this.getFormData();
        });
      });
  }

  downloadFile(fileName, relativePath) {
    this.BusyD = this
      .eErgoFormService
      .downloadFile(fileName, relativePath)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);

        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });
  }

  saveForm(status: string) {
    let updateFormData = this.compileFormData(status);

    this.BusyC = this
      .eErgoFormService
      .updateForm(this.templateName, this.formId, updateFormData)
      .subscribe(result => {
        this.toastsService.showSuccess(`Successfully saved the details.`);

        this.getFormData();
      });
  }

  compileFormData(status: string) {
    let updateFormData = {
      status: this.formData.status,
      managerName: this.formData.managerName,
      employeeEmail: this.formData.employeeEmail,
      employeeEmailNA: this.formData.employeeEmailNA,
      managerEmail: this.formData.managerEmail,
      lensGlasses: this.formData.lensGlasses,
      preventiveEvaluation: this.formData.preventiveEvaluation,
      employeesSymptom: this.formData.employeesSymptom,
      weightAndDistance: this.formData.weightAndDistance,
      toolsUsed: this.formData.toolsUsed,
      pushPullForces: this.formData.pushPullForces,
      temperatureLighting: this.formData.temperatureLighting,
      lengthShiftRotation: this.formData.lengthShiftRotation
    };

    if (status) {
      updateFormData.status = status;
    }

    return updateFormData;
  }

  deleteFile(fileName, relativePath) {
    this.BusyE = this
      .eErgoFormService
      .deleteFile(fileName, relativePath)
      .subscribe(result => {
        this.toastsService.showSuccess(`Successfully deleted '${fileName}'`);
        this.profileVideoFilesColl = [];
        this.rearVideoFilesColl = [];
        this.getFormData();
      });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }

    if (this.BusyC) {
      this.BusyC.unsubscribe();
    }

    if (this.BusyD) {
      this.BusyD.unsubscribe();
    }

    if (this.BusyE) {
      this.BusyE.unsubscribe();
    }

    if (this.BusyF) {
      this.BusyF.unsubscribe();
    }
  }
}
